<template>
    <div>
        <section class="profile-container">
            <div class="profile-container__banner"></div>

            <div class="col-lg-8 offset-lg-2 profile-container__wrapper margin_bottom_lg">
                
                <div class="profile-container__wrapper__details">
                    <div class="row">
                        <div class="col-3 col-lg-2 pl-0">
                            <div class="userAvatar">
                                <img :src="imageUrl" v-if="imageUrl" />
                                <h2 v-else class="font-bold color__white">{{user.fullName | initials}}</h2>
                                
                            </div>
                        </div>
                        <div class="col-9 col-lg-8">
                            <h3 class="font-bold margin_bottom_md mt-2">{{user.fullName}}</h3>
                            <small class="smallFont">Joined in {{moment(user.created_at).format('MMMM, YYYY')}}</small>
                            <div class="row ">
                                <div class="col-lg-3 pr-0 smallFont margin_top_md">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.00004 1.33333C6.58555 1.33333 5.229 1.89524 4.2288 2.89543C3.22861 3.89562 2.66671 5.25218 2.66671 6.66667C2.66671 8.73204 4.01053 10.7362 5.48401 12.2915C6.20712 13.0548 6.93249 13.6796 7.47783 14.1139C7.68078 14.2755 7.85806 14.4101 8.00004 14.5151C8.14202 14.4101 8.3193 14.2755 8.52226 14.1139C9.0676 13.6796 9.79297 13.0548 10.5161 12.2915C11.9895 10.7362 13.3334 8.73204 13.3334 6.66667C13.3334 5.25218 12.7715 3.89562 11.7713 2.89543C10.7711 1.89524 9.41453 1.33333 8.00004 1.33333ZM8.00004 15.3333C7.63024 15.888 7.63007 15.8879 7.62988 15.8878L7.62797 15.8865L7.62353 15.8835L7.60825 15.8732C7.59527 15.8644 7.57676 15.8517 7.55308 15.8353C7.50573 15.8025 7.43768 15.7547 7.3519 15.6928C7.1804 15.5689 6.93761 15.3881 6.64726 15.1569C6.0676 14.6954 5.29297 14.0286 4.51607 13.2085C2.98955 11.5972 1.33337 9.26796 1.33337 6.66667C1.33337 4.89856 2.03575 3.20286 3.286 1.95262C4.53624 0.702379 6.23193 0 8.00004 0C9.76815 0 11.4638 0.702379 12.7141 1.95262C13.9643 3.20286 14.6667 4.89856 14.6667 6.66667C14.6667 9.26796 13.0105 11.5972 11.484 13.2085C10.7071 14.0286 9.93249 14.6954 9.35283 15.1569C9.06247 15.3881 8.81968 15.5689 8.64818 15.6928C8.5624 15.7547 8.49435 15.8025 8.447 15.8353C8.42332 15.8517 8.40481 15.8644 8.39183 15.8732L8.37655 15.8835L8.37211 15.8865L8.3707 15.8875C8.37051 15.8876 8.36984 15.888 8.00004 15.3333ZM8.00004 15.3333L8.36984 15.888C8.14591 16.0373 7.85381 16.0371 7.62988 15.8878L8.00004 15.3333Z"
                                            fill="#959595" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.00004 5.33333C7.26366 5.33333 6.66671 5.93029 6.66671 6.66667C6.66671 7.40305 7.26366 8 8.00004 8C8.73642 8 9.33337 7.40305 9.33337 6.66667C9.33337 5.93029 8.73642 5.33333 8.00004 5.33333ZM5.33337 6.66667C5.33337 5.19391 6.52728 4 8.00004 4C9.4728 4 10.6667 5.19391 10.6667 6.66667C10.6667 8.13943 9.4728 9.33333 8.00004 9.33333C6.52728 9.33333 5.33337 8.13943 5.33337 6.66667Z"
                                            fill="#959595" />
                                    </svg>


                                    {{ user.city}}, {{getState ? getState.name : '' }}
                                </div>
                                <div class="col-lg-5 smallFont margin_top_md">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M2.66663 3.33333C2.30148 3.33333 1.99996 3.63486 1.99996 4V12C1.99996 12.3651 2.30148 12.6667 2.66663 12.6667H13.3333C13.6984 12.6667 14 12.3651 14 12V4C14 3.63486 13.6984 3.33333 13.3333 3.33333H2.66663ZM0.666626 4C0.666626 2.89848 1.5651 2 2.66663 2H13.3333C14.4348 2 15.3333 2.89848 15.3333 4V12C15.3333 13.1015 14.4348 14 13.3333 14H2.66663C1.5651 14 0.666626 13.1015 0.666626 12V4Z"
                                            fill="#959595" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.787195 3.6177C0.998338 3.31607 1.41403 3.24271 1.71566 3.45385L8.00002 7.8529L14.2844 3.45385C14.586 3.24271 15.0017 3.31607 15.2128 3.6177C15.424 3.91933 15.3506 4.33502 15.049 4.54616L8.38232 9.21283C8.15278 9.37351 7.84725 9.37351 7.61771 9.21283L0.951042 4.54616C0.649409 4.33502 0.576052 3.91933 0.787195 3.6177Z"
                                            fill="#959595" />
                                    </svg>

                                    {{user.email}}
                                </div>
                                <div class="col-lg-4 smallFont margin_top_md">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.8592 16C12.1935 16 11.3895 15.8332 10.5053 15.4995C8.56684 14.7687 6.4578 13.3243 4.56671 11.4332C2.67508 9.54157 1.23066 7.43198 0.499304 5.49353C-0.165322 3.73106 -0.166937 2.28449 0.495537 1.62256C0.590791 1.5273 0.687659 1.42505 0.787757 1.31957C1.39211 0.684009 2.07503 -0.0312044 2.98022 0.0010851C3.60394 0.0269167 4.20829 0.414391 4.82718 1.1845C6.65584 3.45876 5.83138 4.26922 4.87723 5.20885L4.70878 5.37568C4.55272 5.53174 4.25781 6.25449 7.00134 8.99802C7.89684 9.89352 8.66048 10.549 9.27075 10.9456C9.655 11.1953 10.3422 11.5731 10.6242 11.2911L10.7937 11.12C11.7323 10.168 12.5428 9.34621 14.8154 11.1733C15.5855 11.7921 15.9724 12.396 15.9983 13.0208C16.0354 13.9254 15.3148 14.6099 14.6787 15.2138C14.5738 15.3139 14.4715 15.4107 14.3763 15.5054C14.0475 15.8348 13.5217 16 12.8592 16ZM2.91564 0.538168C2.27254 0.538168 1.69186 1.14952 1.17792 1.69037C1.0746 1.79907 0.974498 1.90455 0.876015 2.00304C0.382523 2.49599 0.432572 3.79134 1.00302 5.3041C1.70801 7.17259 3.10884 9.21436 4.94772 11.0533C6.78608 12.8911 8.82677 14.2919 10.6958 14.9963C12.2086 15.5679 13.5039 15.6163 13.9963 15.1239C14.0948 15.0254 14.2003 14.9253 14.309 14.8225C14.8617 14.2973 15.4886 13.7021 15.4612 13.0417C15.4424 12.5881 15.1119 12.1 14.4791 11.5914C12.5853 10.0684 12.0557 10.606 11.1775 11.4967L11.0052 11.6705C10.5855 12.0908 9.90363 11.9977 8.978 11.3961C8.33597 10.9784 7.54273 10.2993 6.6214 9.37743C4.34445 7.10101 3.61632 5.70772 4.32884 4.99359L4.50051 4.82406C5.39332 3.94579 5.93202 3.4157 4.40849 1.52085C3.89885 0.888509 3.41128 0.558079 2.95761 0.538706C2.94362 0.538168 2.92963 0.538168 2.91564 0.538168Z"
                                            fill="#959595" />
                                    </svg>

                                    {{user.phoneNo}}

                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-2 d-flex flex-column justify-content-start pr-0">
                            <router-link :to="{ name: 'offtaker.editprofile'}" class="btn btn-secondary btn-sm">Settings</router-link>
                        </div>

                    </div>
                </div>

                <div class="form-container__subheader margin_top_lg">
                    <h4 class="form-container__subheader__title font-bold font-sm caps_upper">My Orders</h4>
                    <div class="form-container__subheader__border"></div>
                </div>

                <div class="mb-3">
                    <div class="crop_offers">
                        
                        <div class="crop_offers__body">
                            <div class="offerContainer">
                                <div class="crop_offers__body__header py-3 px-4 borderBottom">
                                    <div class="row font-bold smallFont">
                                        <div class="col-5 col-lg-5 px-4">ITEM</div>
                                        <div class="col-2 col-lg-2 px-2">QUANTITY <small class="smallFont">(Tons)</small></div>
                                        <div class="col-3 col-lg-3 px-4">PRICE</div>
                                        <div class="col-2 col-lg-2 px-4">OPTIONS</div>
                                    </div>
                                </div>
                
                                <div class="crop_offers__body__body">
                                    <span>
                                        <order-row v-for="(order, index) in orders" :key="index" :order="order" />
                                    </span>

                                    <div v-if="orders.length === 0 && !gettingOrders" class="margin_top_md">
                                        <EmptyComponent>You have no orders currently</EmptyComponent>
                                    </div>
                                    
                                </div>
                            </div>
                
                        </div>
                
                    </div>
                </div>
            </div>

            
            
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import OrderRow from '@/components/off-taker/userprofile/OrderRow';
import EmptyComponent from '@/components/utils/EmptyComponent';

export default {
    data() {
        return {
            moment,
            orders: [],
            gettingOrders: false
        }
    },
    computed: {
        ...mapState(['user','states']),
        getState() {
            return this.states ? this.states.find(item => item.id === this.user.state_id) : ''
        },
        imageUrl() {
            return this.user.avatar ? this.user.avatar : ''
        }
    },
    methods: {
        ...mapActions(['getStates']),
        checkStates() {
            if (this.states.length === 0) {
                this.getStates();
            }
        },
        getOrders() {
            this.gettingOrders = true;
            this.$http.get('crop_orders')
            .then((response) => {
                this.orders = response.data.items
                this.$log('Orders ',response)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.gettingOrders = false;
            })
        }
    },
    created() {
        this.checkStates();
        this.getOrders();
    },
    components: {
        OrderRow,
        EmptyComponent
    }
}
</script>